class TimelineScale {
	constructor(timeline) {
		this._timeline = timeline;
		this.gotoDate = null;

		this._majorInterval; // interval between divisions
		this._minorInterval; // interval between sub divisions

		this._bar = new ScaleBar(this, timeline);
		this._bg = new ScaleBackground(this);
	}

	get bar() {return this._bar._bar;}
	get background() {return this._bg._elem;}

	get start() {return this._timeline.viewStartMilliseconds;}
	get end() {return this._timeline.viewEndMilliseconds;}
	get major() {return this._majorInterval;}
	get minor() {return this._minorInterval;}

	init() {
		this.setIntervals();
		this._bar.init();
		this._bg.init();
	}

	setIntervals() {
		let div = this._timeline.getDaysInView();

		if (div < 0.25) {
			this._minorInterval = 300000; // 5 mins
			this._majorInterval = 1800000; // 30 mins
		} else if (div < 0.75) {
			this._minorInterval = 1800000; // 30 mins
			this._majorInterval = 3600000; // 60 mins
		} else if (div < 1.75) {
			this._minorInterval = 3600000; // 1 hour
			this._majorInterval = 21600000; // 6 hours
		} else if (div < 4) {
			this._minorInterval = 21600000; // 6 hours
			this._majorInterval = 86400000; // 24 hours
		} else {
			this._minorInterval = 86400000; // 1 day
			this._majorInterval = 604800000; // 7 days
		};
	}

	scaleChange() {
		this.setIntervals();
		this._bar.scaleChange();
		this._bg.scaleChange();
		this.update();
	}

	update() {
		this._bar.update();
		this._bg.update();
	}
}
